/**
 * UPS Swiper
 */

import Swiper, { Autoplay } from 'swiper';

jQuery( $ => { // eslint-disable-line no-unused-vars
	new Swiper( '.usp-swiper', {
		modules: [ Autoplay ],
		slidesPerView: 1,
		autoplay: {
			delay: 3000,
			disableOnInteraction: false,
		},
		breakpoints: {
			992: {
				slidesPerView: 'auto',
			},
		},
	} );
} );
